var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPineapple1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 177,
    viewBox: "0 0 190 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8898 125.572C30.5587 153.627 59.6082 170.129 87.7737 162.43C115.939 154.731 132.555 125.747 124.886 97.6914C117.217 69.636 88.1676 53.134 60.0021 60.8331C31.8366 68.5321 15.2208 97.5168 22.8898 125.572Z",
    fill: "#65A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.587 41.6596C103.734 56.6583 107.189 75.0367 107.189 75.0367C107.189 75.0367 124.998 69.0974 133.851 54.0987C142.704 39.0999 139.249 20.7215 139.249 20.7215C139.249 20.7215 121.441 26.6608 112.587 41.6596Z",
    fill: "#65D58D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.855 43.8924C119.897 61.2786 107.592 75.4269 107.592 75.4269C107.592 75.4269 95.2194 61.3863 95.1778 44.0001C95.1362 26.6138 107.441 12.4656 107.441 12.4656C107.441 12.4656 119.814 26.5061 119.855 43.8924Z",
    fill: "#65A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.691 56.6419C118.889 61.3502 108.585 77.0048 108.585 77.0048C108.585 77.0048 125.524 85.0257 142.327 80.3173C159.129 75.6089 169.433 59.9543 169.433 59.9543C169.433 59.9543 152.494 51.9335 135.691 56.6419Z",
    fill: "#35449F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.364 63.2752C127.296 75.8546 108.603 77.5633 108.603 77.5633C108.603 77.5633 109.475 58.8768 121.543 46.2974C133.611 33.718 152.304 32.0093 152.304 32.0093C152.304 32.0093 151.431 50.6958 139.364 63.2752Z",
    fill: "#FFDD65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3397 113.127C54.2806 127.545 69.2089 136.025 83.6828 132.068C98.1568 128.112 106.695 113.217 102.754 98.7996C98.8134 84.3823 83.8852 75.9021 69.4113 79.8586C54.9373 83.815 46.3987 98.7099 50.3397 113.127Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5989 98.2889C57.877 102.965 62.7186 105.715 67.4129 104.432C72.1071 103.149 74.8764 98.318 73.5982 93.6421C72.3201 88.9662 67.4785 86.2159 62.7843 87.499C58.09 88.7822 55.3207 93.613 56.5989 98.2889Z",
    fill: "#35449F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.472,
    height: 158.659,
    fill: "white",
    transform: "translate(153.044) rotate(74.7117)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPineapple1);
export default __webpack_public_path__ + "static/media/imgPineapple1.3ce739662f8012d0b616db518a04650b.svg";
export { ForwardRef as ReactComponent };